<script>
    import { url, layout } from '@sveltech/routify'
    import { t } from 'totalinvoice-frontend-core'

    const currentYear = new Date().getFullYear()

    const redirectLinks = $layout.parent.children.filter(c => c.meta['showInFooter'])
    const socialLinks = $layout.parent.children.filter(c => c.meta['showInSocialLinks'])
</script>

<footer class="footer">

    <!-- Social links -->
    <section class="section footer-social-links">
        <div class="columns is-centered is-vcentered">
            <div class="column is-narrow">
                <h3 class="subtitle is-3">{$t('Follow us')}</h3>
            </div>
            <ul class="column is-narrow">
                {#each socialLinks as node}
                    <li>
                        <a href={$url(node.path)} title={$t(`Follow us on ${node.title} (new window)`)} target="_blank">
                            <img src={node.meta["icon"]} alt={node.title}>
                        </a>
                    </li>
                {/each}
            </ul>
        </div>
    </section>

    <!-- Redirect links -->
    <section class="section footer-redirect-links">
        <ul>
            {#each redirectLinks as node}
                <li>
                    <a href={$url(node.path)}>{$t(node.title)}</a>
                </li>
            {/each}
            <li>&copy; TotalEnergies - {currentYear}</li>
        </ul>
    </section>

</footer>
